<template>
    <div class="playerNameField mt-2">
        <label>
            Name:
            <strong v-if="!editMode" @click="switchToEditMode()">{{ name }}</strong>
            <form v-else v-on:submit.prevent="saveName">
                <b-input
                    maxlength="20"
                    trim
                    size="sm"
                    @blur="saveName"
                    v-model="editName"
                    id="playerNameInputQuickSave"
                    placeholder="Enter our name"
                ></b-input>
            </form>
        </label>
        <unicon
            v-if="!editMode"
            @click="switchToEditMode()"
            class="editButton ml-1"
            name="edit-alt"
        />
    </div>
</template>
<script>
import store from "@/store";
export default {
    data: () => {
        return {
            editName: store.state.player.name,
            editMode: false
        };
    },
    methods: {
        saveName: function() {
            this.editMode = false;
            if (!this.editName.trim().length) return;
            store.dispatch("setPlayerName", this.editName);
        },
        switchToEditMode: function() {
            this.editMode = true;
            setTimeout(() => {
                document.getElementById("playerNameInputQuickSave").select();
            }, 100);
        }
    },
    computed: {
        name: () => store.state.player.name
    }
};
</script>
